export default __webpack_public_path__ + "static/rovo-menu-dont-dark-b447350f93023cdf718b0546ea869b564cd4b3bfc73683b444955fc0bf09eea4.png";